import React, { Component, useState, useEffect, useRef } from "react";
import { WizardView, WizardContextProvider } from "../Wizard";
import { Chart, Line } from "react-chartjs-2";
import IonRangeSlider from "react-ion-slider";
function SignalCalibrationWizard(props) {
    const [calibrationTypeId, setCalibrationTypeId] = useState(0);
    const [lowCalibration, setLowCalibration] = useState(0);
    const [highCalibration, setHighCalibration] = useState(100);
    const [lowCalibrationDataset, setLowCalibrationDataset] = useState([]);
    const [highCalibrationDataset, setHighCalibrationDataset] = useState([]);

    const calibrationChart = useRef(null);

    const [chartData, setChartData] = useState({
        datasets: [
            {
                label: "Low Calibration",
                // data: [
                //     { x: 0, y: 0 },
                //     { x: 1, y: 0 },
                // ],
                data: [],
                fill: true,
                backgroundColor: "#ffffff",
                borderColor: "#0000ff",
            },
            {
                label: "High Calibration",
                // data: [
                //     { x: 0, y: 100 },
                //     { x: 1, y: 100 },
                // ],
                data: [],
                fill: true,
                backgroundColor: "#ffffff",
                borderColor: "#ff0000",
            },
        ],
    });

    useEffect(() => {
        // const chart = calibrationChart.current;
        // if (chart) {
        //     console.log("CanvasRenderingContext2D", chart.ctx);
        //     console.log("HTMLCanvasElement", chart.canvas);
        // }
    }, []);

    useEffect(() => {
        chartData.datasets[0].data = [
            { x: 0, y: lowCalibration },
            { x: 1, y: lowCalibration },
        ];
        chartData.datasets[1].data = [
            { x: 0, y: highCalibration },
            { x: 1, y: highCalibration },
        ];
        setChartData(chartData);
        const chart = calibrationChart.current;
        if (chart) {
            console.log("CanvasRenderingContext2D", chart.ctx);
            console.log("HTMLCanvasElement", chart.canvas);
        }
    }, [lowCalibration, highCalibration]);

    return (
        <WizardContextProvider
            name={`Calibrate ${props.signalUnderCalibration?.name}`}
            onClose={props.onClose}
            onFinish={props.onFinish}
            onNext={(manifest) => {
                console.log("Wizard::next");
                return true;
            }}
            onBack={(manifest) => {
                console.log("Wizard::back");
                return true;
            }}
            canClose={true}
        >
            <WizardView.Page
                title={`Endpoints`}
                onNextRequested={() => {
                    console.log("Endpoints::next");
                    return true;
                }}
                onBackRequested={() => {
                    console.log("Endpoints::back");
                    return true;
                }}
            >
                <div className="contianer-fluid">
                    <div className="row">
                        <div className="col-5">
                            <div class="card card-info card-outline">
                                <div class="card-header">
                                    <h3 class="card-title">
                                        Choose Calibration Type
                                    </h3>
                                </div>
                                <div class="card-body pad table-responsive">
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            name="radio1"
                                            checked=""
                                        />
                                        <label class="form-check-label">
                                            Self Calibration
                                        </label>
                                        <div>
                                            <small>
                                                Signal calibrates itself based
                                                on the maximum and minimum
                                                values ever noted after the last
                                                calibration date
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            name="radio1"
                                            checked=""
                                        />
                                        <label class="form-check-label">
                                            Smart Calibration
                                        </label>
                                        <div>
                                            <small>
                                                Signal calibrates itself based
                                                on the maximum and minumum
                                                values that it reads after
                                                you've created the correct
                                                environmental conditions!
                                            </small>
                                        </div>
                                    </div>
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            name="radio1"
                                            checked=""
                                        />
                                        <label class="form-check-label">
                                            Simple Calibration
                                        </label>
                                        <div>
                                            <small>
                                                Signal calibrates itself based
                                                on the values chosen manually
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div class="container-fluid">
                                <div class="row">
                                    <Line
                                        redraw
                                        options={{
                                            responsive: true,
                                            plugins: {
                                                legend: {
                                                    position: "top",
                                                },
                                                title: {
                                                    display: true,
                                                },
                                                tooltip: {
                                                    callbacks: {
                                                        label: function (
                                                            context
                                                        ) {
                                                            return `${
                                                                context.dataset
                                                                    .label || ""
                                                            } ${context.parsed.y.toFixed(
                                                                2
                                                            )}%`;
                                                        },
                                                    },
                                                },
                                            },
                                            scales: {
                                                x: {
                                                    display: false,
                                                    type: "linear",
                                                },
                                                y: {
                                                    type: "linear",
                                                    display: true,
                                                    grid: {
                                                        drawOnChartArea: true,
                                                    },
                                                    max: 100,
                                                    min: 0,
                                                    ticks: {
                                                        callback: function (
                                                            label,
                                                            index,
                                                            labels
                                                        ) {
                                                            return label + "%";
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                        ref={calibrationChart}
                                        data={chartData}
                                    />
                                    ;
                                </div>
                                <div className="row">&nbsp;</div>
                                <div className="row">&nbsp;</div>
                                <div className="row">
                                    <div className="col-12">
                                        <IonRangeSlider
                                            skin={"flat"}
                                            force_edges
                                            type={"double"}
                                            min={0}
                                            max={100}
                                            from={lowCalibration}
                                            to={highCalibration}
                                            onChange={async (e) => {
                                                await setLowCalibration(e.from);
                                                await setHighCalibration(e.to);
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-2">&nbsp;</div>
                                    <div className="col-8 d-flex justify-content-center">
                                        <button
                                            class="btn btn-outline btn-outline-primary mr-2"
                                            onClick={() => {
                                                calibrationChart.current.update();
                                            }}
                                        >
                                            Mark Low
                                        </button>
                                        <button class="btn btn-outline-danger mr-2">
                                            Mark High
                                        </button>
                                    </div>
                                    <div className="col-2">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WizardView.Page>
            <WizardView.Page
                title="Transitions"
                onNextRequested={() => {
                    console.log("transitions::next");
                    return true;
                }}
                onBackRequested={() => {
                    console.log("transitions::back");
                    return true;
                }}
            >
                <div className="continaer-fluid">
                    <div className="row">
                        <div className="col-6">
                            <div class="card card-info card-outline">
                                <div class="card-header">
                                    <h3 class="card-title">
                                        Specify Transition Thresholds
                                    </h3>
                                </div>
                                <div class="card-body pad table-responsive">
                                    Drag the handles on the right to specify the
                                    transition thresholds.
                                    <blockquote class="quote-danger">
                                        <p>
                                            A datapoint recorded above the high
                                            threshold will be considered as a{" "}
                                            <b>high</b> value.
                                        </p>
                                    </blockquote>
                                    <blockquote class="quote-success">
                                        <p>
                                            A datapoint recorded below the low
                                            threshold will be considered as a{" "}
                                            <b>low</b> value.
                                        </p>
                                    </blockquote>
                                    <blockquote class="quote-secondary">
                                        <p>
                                            Any transitions that lie within this
                                            dead zone will be ignored!
                                        </p>
                                        <small>
                                            Try to keep this window{" "}
                                            <cite title="Source Title">
                                                as thin as possible!
                                            </cite>
                                        </small>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </WizardView.Page>
        </WizardContextProvider>
    );
}

export default SignalCalibrationWizard;
